"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, Diamond } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function PrivateEquitySolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const pillars = [{
    title: "Biyouyumlu Titanyum",
    points: ["Vücut dokularıyla tam uyumlu materyaller", "Ömür boyu dayanıklılık ve kullanım konforu", "Çene kemiği erimesini önleyen yapı"]
  }, {
    title: "Doğal Estetik Görünüm",
    points: ["Kendi dişinizden ayırt edilemeyen sonuçlar", "Tam konuşma ve çiğneme fonksiyonu", "Yüz hatlarını koruyan estetik destek"]
  }, {
    title: "Modern Cerrahi Teknikler",
    points: ["Ağrısız ve hızlı uygulama süreçleri", "Dijital planlama ile yüksek hassasiyet", "Minimum sürede hızlı iyileşme imkanı"]
  }];
  return <section data-section-id="30565" id="implant-tedavisi-hakkında-bilgi" ref={ref} className="bg-background relative w-full overflow-hidden py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20 items-center">
          {/* Visual Column */}
          <div className={cn("relative h-full min-h-[500px] w-full overflow-hidden rounded-sm transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <div className="absolute inset-0 bg-primary/5 mix-blend-overlay z-10" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/dental_implant_technology.png" alt="Modern dental implant teknolojisi ve detaylı görünümü" className="h-full w-full object-cover object-center grayscale-0 contrast-100 shadow-md" />
            {/* Asymmetrical Frame Effect */}
            <div className="absolute inset-4 border-[0.5px] border-primary/40 z-20 pointer-events-none" />
          </div>

          {/* Content Column */}
          <div className={cn("flex flex-col gap-8 transition-all duration-1000 delay-300 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="space-y-4">
              <span className="text-primary font-mono text-sm tracking-widest uppercase">
                UZMAN DİŞ HEKİMLİĞİ
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-foreground tracking-widest">
                İmplant Tedavisi Hakkında Bilgi
              </h2>
              <p className="text-muted-foreground text-base leading-relaxed max-w-xl font-sans">
                Eksik dişlerin yerine çene kemiğine yerleştirilen titanyum vidalarla yapılan implant tedavisi, doğal diş kökü görevini üstlenerek en sağlıklı ve estetik çözümü sunar. Uzman hekimlerimiz ve en son teknoloji ekipmanlarımızla gülüşünüzü modern tıbbın imkanlarıyla yeniden inşa ediyoruz.
              </p>
            </div>

            <div className="grid gap-6">
              {pillars.map((pillar, i) => <Card key={i} data-index={i} className="bg-card border-primary/20 shadow-md hover:border-primary/40 transition-colors duration-300 group">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-xl font-serif text-foreground group-hover:text-primary transition-colors">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-2">
                      {pillar.points.map((point, j) => <li key={j} data-index={j} className="flex items-start gap-3 text-sm text-muted-foreground font-sans">
                          <div className="mt-1.5">
                            <div className="h-1.5 w-1.5 rotate-45 bg-primary" />
                          </div>
                          <span>{point}</span>
                        </li>)}
                    </ul>
                  </CardContent>
                </Card>)}
            </div>

            <div className="pt-4">
              <Button asChild variant="outline" className="border-primary/50 text-foreground hover:bg-primary/10 hover:text-primary transition-all">
                <Link to="/ContactPage">
                  Randevu Alın <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}